import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { colors, fontWeights, breakpoints } from '@/styles'
import { handlePDFView } from '@/pages/Contract/ContractManager/tenancy-documents/pdf-view'
import { Button } from '@/components/button'
import useMediaQuery from '@/hooks/use-media-query'
import ExportIcon from './export-icon.svg?react'

const TopProgressBar = styled.div`
  width: 100%;
  height: 48px;
  background-color: #27567d;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: ${colors.white};
  font-size: 14px;
  line-height: 16px;
  font-weight: ${fontWeights.medium};
  padding: 0 24px;
  position: sticky;
  top: 53px;
  z-index: 10;
  min-height: 48px;
`

const ChevronNext = styled.div`
  width: 16px;
  height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
  color: ${colors.blue16};
`

const SigningCompleteComponent = ({ contractId, currentDocumentId }) => {
  const { t } = useTranslation()
  const handleContractView = () => handlePDFView(contractId, currentDocumentId)
  const isMobile = useMediaQuery(`(max-width: ${breakpoints.phoneMax})`)
  const padding = isMobile ? '6px 8px' : '8px 16px'
  return (
    <TopProgressBar>
      <div>
        {t(
          'l.contract_edit.document_widget.sigining_complete.label',
          'This contract is now complete.'
        )}
      </div>
      <Button
        theme="secondary"
        size="small"
        padding={padding}
        minHeight="unset"
        type="submit"
        onClick={handleContractView}
      >
        <>
          <ChevronNext>
            <ExportIcon />
          </ChevronNext>
          {t('l.contract_edit.document_widget.export_as_pdf.label', 'Export as PDF')}
        </>
      </Button>
    </TopProgressBar>
  )
}

export default SigningCompleteComponent
